import angular from "angular";
import component from "./direction-options-control.component";
let mod = angular.module('DirectionOptionsControl', [component]);
export default mod.name;




// WEBPACK FOOTER //
// ./resources/assets/modules/direction-options-control/direction-options-control.module.js